import { backendApi } from "./backend.api";
import { IPayment } from "shared/models/models";
import { getSpaceId } from "shared/utils/space";

export interface IPaymentListQuery {
  title?: string;
  serial?: string;
  equalSerial?: boolean;
  provider?: number;
  address?: number;
  spaceId?: number;
  ids?: number[];
  orderBy?: string;
}

interface IPaymentTitlesQuery {
  spaceId?: number;
}

export const paymentApi = backendApi.injectEndpoints({
  endpoints: (build) => {
    return {
      payments: build.query<IPayment[], IPaymentListQuery>({
        query: (queryParams) => {
          const spaceId = getSpaceId();
          const params: IPaymentListQuery = { ...queryParams };
          if (spaceId) {
            params.spaceId = spaceId;
          }
          return {
            url: "/payment",
            method: "GET",
            params: params,
          };
        },
        providesTags: (result, error, arg) =>
          result
            ? [
                ...result.map(({ id }) => ({ type: "Payment" as const, id })),
                "Payment",
              ]
            : ["Payment"],
      }),
      getPaymentTitles: build.query<string[], null>({
        query: () => {
          const spaceId = getSpaceId();
          const params: IPaymentTitlesQuery = {};
          if (spaceId) params.spaceId = spaceId;
          return {
            url: "/payment/titles",
            method: "GET",
            params: params,
          };
        },
      }),
      getPayment: build.query<IPayment, number>({
        query: (id) => ({ url: `/payment/${id}`, method: "GET" }),
        transformErrorResponse: (response: { route: string | number }) =>
          response.route,
        providesTags: (item) => [{ type: "Payment", id: item?.id }],
      }),
      addPayment: build.mutation<IPayment, Partial<IPayment>>({
        query: (payload) => {
          const spaceId = getSpaceId();
          const params: Partial<IPayment> = { ...payload };
          if (spaceId) {
            params.spaceId = spaceId;
          }
          return {
            url: "/payment",
            method: "POST",
            data: params,
          };
        },
        invalidatesTags: () => ["Payment"],
        transformResponse: (response: { data: IPayment }) => response.data,
      }),
      updatePayment: build.mutation<IPayment, Partial<IPayment>>({
        query: (payload) => ({
          url: `/payment/${payload.id}`,
          method: "PATCH",
          data: payload,
        }),
        invalidatesTags: (item) => [{ type: "Payment", id: item?.id }],
        //transformResponse: (result, error) => [{ type: 'Visit', id: result?.id }],
      }),
      updateMultiPayment: build.mutation<IPayment[], IPayment[]>({
        query: (payload) => ({
          url: "/payment/update-multi",
          method: "POST",
          data: payload,
        }),
        invalidatesTags: (result = []) => [
          ...result.map(({ id }) => ({ type: "Payment", id: id }) as const),
        ],
        // transformResponse: (response: { data: IVisit[] }) => response.data,
      }),
      deletePayment: build.mutation<IPayment, number>({
        query: (id) => ({
          url: `/payment/${id}`,
          method: "DELETE",
          credentials: "include",
        }),
        invalidatesTags: ["Payment"],
      }),
    };
  },
});

export const {
  usePaymentsQuery,
  useAddPaymentMutation,
  useDeletePaymentMutation,
  useGetPaymentQuery,
  useUpdatePaymentMutation,
  useGetPaymentTitlesQuery,
  useUpdateMultiPaymentMutation,
} = paymentApi;
